import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Route, Routes, useParams } from 'react-router-dom';
import { setPageTitle } from 'store/actions/header';
import { PageContentWrapper } from 'app/layouts/wrapper/page-content';
import { useContactService } from 'hooks/users/contact';
import { GridColumn, GridRow } from 'app/layouts/grid';
import { ContactViewStatBar } from './components/statbar';
import { Spacer } from 'app/layouts/generic';
import { Maillogs } from './components/logs';
import { ClickLogs } from './components/clicks';
import SlidingNav from 'app/shared/nav/sliding/sliding';
import useScreenSize from 'hooks/size';
import ContactDetails from './components/details';
import { ContactCustomInformation } from './components/basic-info';
import { flattenObject } from 'app/shared/utils/text';

const DEFAULT_KEYS = ['firstname', 'lastname', 'email', 'phone_number', 'gender'];

export const ContactPage = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { fetchContact } = useContactService();
  const { isMobile } = useScreenSize();
  const [contact_data, setContactData] = useState({});

  useEffect(() => {
    if (!id) return;
    fetchContact(id).then((contact) => {
      if (!contact) return;

      const { firstname, lastname, email } = contact;
      const name_parts = [firstname, lastname].filter(Boolean);
      const full_name = name_parts.length ? name_parts.join(' ') : email;

      setContactData(() => ({ ...contact }));

      dispatch(
        setPageTitle([
          { title: 'Contacts', path: '/contacts' },
          { title: full_name || email, path: '.' }
        ])
      );
    });
  }, [id]);

  const nav_config = [
    { title: 'Details', path: `/contacts/${id}` },
    { title: 'Email logs', path: `/contacts/${id}/emails` },
    { title: 'Click logs', path: `/contacts/${id}/clicks` }
  ];

  const extractExtraData = (payload = {}) => {
    const e_data = { ...(payload.extra_data || {}) };
    const date_keys = e_data?.date_property_keys || [];
    delete e_data?.date_property_keys;
    for (const key of DEFAULT_KEYS) {
      delete e_data[key];
    }
    return { data: flattenObject(e_data || {}, true), date_keys };
  };

  return (
    <div className="dt-content-wrapper">
      <PageContentWrapper>
        <GridRow>
          {!isMobile && (
            <GridColumn>
              <ContactDetails contact_data={contact_data} setContactData={setContactData} />
            </GridColumn>
          )}
          <GridColumn span={!isMobile ? 3 : 4}>
            {isMobile && <SlidingNav nav_items={nav_config} />}
            {!isMobile && <ContactViewStatBar />}
            {!isMobile && <SlidingNav nav_items={nav_config} />}
            <Spacer multiple={4} />
            <Routes>
              <Route path="clicks" element={<ClickLogs email={contact_data.email} />} />
              <Route path="emails" element={<Maillogs email={contact_data.email} />} />
              <Route
                path="/*"
                element={
                  !isMobile ? (
                    <ContactCustomInformation {...extractExtraData(contact_data)} />
                  ) : (
                    <ContactDetails contact_data={contact_data} setContactData={setContactData} />
                  )
                }
              />
            </Routes>
          </GridColumn>
        </GridRow>
      </PageContentWrapper>
    </div>
  );
};
